module.exports = __webpack_public_path__ + "static/media/ask-expert-preview.74796189.png";